import Styles from "css/login_css/loading.module.css";

export default function OnlyLoadingScreen({ isOpen }) {
    if (!isOpen) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
                flexDirection: "column",
            }}
        >
            <div
                style={{
                    width: "60px",
                    height: "60px",
                    border: "6px solid #f3f3f3",
                    borderTop: "6px solid #3498db",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                }}
            />
            <p style={{ color: "#fff", marginTop: "16px", fontSize: "16px" }}>
                처리 중입니다...
            </p>

            {/* 애니메이션 keyframes를 inline으로 직접 줄 수 없으므로, 아래를 꼭 스타일 태그로 함께 사용해야 함 */}
            <style>
                {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
            </style>
        </div>
    );
}
